/** The number of digits to display for report ids. Integers will be left-padded with 0s. */
export const REPORT_ID_DISPLAY_LENGTH = 6;

export const StatusNames = {
  PUBLISHED: 'published',
  REJECTED: 'rejected',
  REVIEWABLE: 'reviewable',
  APPROVED: 'approved',
  DRAFT: 'draft',
} as const;

export const IncidentStatusNames = {
  OPEN: 'open',
  CLOSED: 'closed',
} as const;

export const SupplementalTypes = {
  ATTACHMENT: 'attachment',
  ADDENDUM: 'addendum',
} as const;

export const SupplementalTypeNames: UnionMap<SupplementalType, string> = {
  addendum: 'Addendum',
  attachment: 'Attachment',
};

export const REPORT_STATUSES: StatusName[] = [StatusNames.PUBLISHED, 'approved', 'reviewable', 'rejected', 'draft'];

export const REPORT_STATUS_NAMES: UnionMap<StatusName, string> = {
  draft: 'Draft',
  reviewable: 'Ready for Review',
  rejected: 'Needs Revision',
  approved: 'Approved',
  published: 'Published',
};

export const INCIDENT_STATUSES: string[] = ['OPEN', 'CLOSED'];

export const INCIDENT_STATUS_NAMES: UnionMap<string, string> = {
  OPEN: 'Open',
  CLOSED: 'Closed',
};

export const INCIDENT_FILTERS_BY_STATUS: UnionMap<string, ListGroupFilters> = {
  OPEN: { investigation_status: 'OPEN' },
  CLOSED: { investigation_status: 'CLOSED' },
};

export const REPORT_STATUSES_BY_ROLE: UnionMap<ReportUserType, StatusName[]> = {
  AUTHOR: ['draft', 'rejected', 'reviewable', 'approved', StatusNames.PUBLISHED],
  REVIEWER: ['rejected', 'reviewable', 'approved', StatusNames.PUBLISHED],
  STAFF: [StatusNames.PUBLISHED],
};

export const REPORT_FILTERS_BY_STATUS: UnionMap<StatusName, ListGroupFilters> = {
  draft: { status__name: 'draft' },
  rejected: { status__name: 'rejected' },
  reviewable: { status__name: 'reviewable' },
  approved: { status__name: 'approved' },
  published: { status__name: StatusNames.PUBLISHED },
};

interface StatusDescription {
  title: string
  description: string
};

export const REPORT_STATUS_DESCRIPTIONS: UnionMap<StatusName, StatusDescription> = {
  draft: {
    title: 'Drafts',
    description: 'Reports that have not yet been submitted for review.',
  },
  rejected: {
    title: 'Needs Revision',
    description: 'Reports that have been reviewed and deemed revisions are needed. These must be updated and resubmitted for review.',
  },
  reviewable: {
    title: 'Ready for Review',
    description: 'Reports that have been submitted for review and are awaiting approval. Editing these reports will mark them as revisions, and they will need to be resubmitted for review.',
  },
  approved: {
    title: 'Ready to Publish',
    description: 'Reports that have been approved, and are ready to be published.',
  },
  published: {
    title: 'Published',
    description: 'Reports that have been published for organization-wide viewing.',
  },
};

export const DELETE_REPORT_PROMPT = 'Are you sure you want to delete this report?';
export const STATUS_ACTION_PREFIX = 'status:';

export const REPORT_ICONS = {
  IR: 'mdi:text-box-outline',
  SR: 'mdi:text-box-plus-outline',
  PS: 'mdi:account-file-text-outline',
  default: 'mdi:file-outline',
};
